/** Форматирование стоимости OpenRouter в рублях по курсу из настроек. */

export function getUsdRubRate(settings) {
    const rate = Number(settings?.usd_rub_rate);
    return Number.isFinite(rate) && rate > 0 ? rate : 90;
}

export function formatUsdCost(usdAmount, settings, { withUsd = false } = {}) {
    if (usdAmount == null || usdAmount === '') return null;
    const usd = Number(usdAmount);
    if (!Number.isFinite(usd)) return null;
    const rate = getUsdRubRate(settings);
    const rub = usd * rate;
    const rubStr =
        rub >= 100
            ? `${Math.round(rub).toLocaleString('ru-RU')} ₽`
            : rub >= 1
              ? `${rub.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽`
              : `${rub.toLocaleString('ru-RU', { maximumFractionDigits: 4 })} ₽`;
    if (!withUsd) return rubStr;
    return `${rubStr} ($${usd.toFixed(usd < 0.01 ? 6 : 4)})`;
}

export function formatModelPricing(pricing, settings) {
    if (!pricing) return '';
    const prompt = pricing.prompt ?? pricing.input;
    const completion = pricing.completion ?? pricing.output;
    const rate = getUsdRubRate(settings);
    const fmt = (v) => {
        if (v == null) return null;
        const n = Number(v);
        if (Number.isNaN(n)) return String(v);
        // OpenRouter часто отдаёт цену за токен
        const perMUsd = n < 0.01 ? n * 1_000_000 : n;
        const perMRub = perMUsd * rate;
        return `${perMRub.toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ₽/M`;
    };
    const a = fmt(prompt);
    const b = fmt(completion);
    if (a && b) return `${a} → ${b}`;
    return a || b || '';
}

/** Средняя стоимость одного изображения по накопленной статистике пользователя */
export function formatAvgImageCost(stat, settings) {
    if (!stat) return null;
    const avg =
        stat.avg_cost_usd != null
            ? Number(stat.avg_cost_usd)
            : stat.image_count > 0
              ? Number(stat.total_cost_usd) / Number(stat.image_count)
              : null;
    if (avg == null || !Number.isFinite(avg) || avg < 0) return null;
    const rub = formatUsdCost(avg, settings);
    if (!rub) return null;
    const n = Number(stat.image_count) || 0;
    return n > 0 ? `~${rub} / фото · ${n}` : `~${rub} / фото`;
}
